import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetPatientGroupItemsDocument,
  PatientGroupItemDataFragment,
} from '../../types/api/graphql';

export function usePatientGroupItems(
  healthProviderId: string | null | undefined
) {
  const { data: patientGroupItemsData, loading: patientGroupItemsLoading } =
    useCacheQuery(GetPatientGroupItemsDocument, {
      variables: {
        healthProviderId: healthProviderId ?? '',
      },
      skip: !healthProviderId,
    });

  const data = useMemo(
    () =>
      (patientGroupItemsData?.patientGroupNumbers ?? []).map(
        option => option as PatientGroupItemDataFragment
      ),
    [patientGroupItemsData?.patientGroupNumbers]
  );

  return {
    data,
    loading: patientGroupItemsLoading,
  };
}
